<template>
	<div class="details">
		<!-- 视频详情 -->
		<video @ended="onEnd" controls :src="currentVideo?.videoUrl"></video>
		<div class="box">
			<p class="title">{{currentVideo?.name}}</p>
			<p class="desc">{{currentVideo?.remarks}}</p>
		</div>

		<div class="diver"></div>

		<div class="box">
			<p class="title-sort flex between">
				<span>分集</span>
				<!-- @click="visable=true" -->
				<span class="flex">共{{videosDetails?.length}}集</span>
			</p>
			<div class="tabs flex start">
				<div @click="currentVideoIndex=index" v-for="(item,index) in videosDetails" :key="index" :class="{'active':readRecords.includes(item.id)||currentVideoIndex==index}" class="tab flex center">{{item.name}}</div>
			</div>
		</div>

		<!-- 运动学习-学习模式-专项训练 有对应练习视频 -->
		<div v-if="videosDetails.exerciseVideoList?.length" class="exercise-list">
			<p class="title">对应练习视频</p>
			<VideoCard v-for="(item,index) in videosDetails.exerciseVideoList" :key="index" :videoInfo="item" />
		</div>

		<popup v-model="visable" type="bottom" :showClose="true" @confirm="1" @close="visable=false">
			<div class="popup-contain">
				<p>
					分集
					<span>({{videosDetails?.length}})</span>
				</p>
				<div class="tabs flex start">
					<div @click="currentVideoIndex=index,visable=false" v-for="(item,index) in videosDetails" :key="index" :class="{'active':currentVideoIndex==index}" class="tab flex center">{{item.name}}</div>
				</div>
			</div>
		</popup>
	</div>
</template>

<script>
import VideoCard from "@student/videos/child/videoCard.vue";
export default {
	components: {
		VideoCard,
	},
	data() {
		return {
			defaultVideo: "",
			visable: false,
			currentVideoIndex: 0,
			videosDetails: [],

			homeworkId: undefined,
			workId: undefined,	//作业ID													
			readRecords:[],//作业 - 已读进度
		};
	},

	computed: {
		currentVideo() {
			return this.videosDetails?.[this.currentVideoIndex];
		},
	},

	mounted() {
		this.getDetails();
		let homeworkId = this.$route.query.homeworkid;
		if (homeworkId) {
			this.homeworkId = homeworkId;
			this.getReadRecords();
		}
	},

	methods: {
		onEnd() {
			console.log("onEnd", this.$route.query.homeworkid);
			// 作业 & 未预览 - 提交
			// if (this.$route.query.homeworkid && !this.readRecords.includes(this.currentVideo.id) ) this.submitReadRecords();
			if (this.$route.query.homeworkid) this.submitReadRecords();
		},

		async getDetails() {
			try {
				let { success, message, result } = await this.$http.get(
					`h5/videos/getVideos?videoCollectionId=${this.$route.query.videosId}`
				);
				if (!success) throw new Error(message);
				this.videosDetails = result;
			} catch (error) {
				console.log("getDetails", error?.message);
			}
		},

		// 作业 - 获取已阅读进度
		async getReadRecords() {
			try {
				let { success, message, result } = await this.$http.get(
					`h5/examineWork/listFinisVideo?videoCollectionId=${this.$route.query.videosId}&workId=${this.homeworkId}`
				);
				if (!success) throw new Error(message);
				this.readRecords = result;
			} catch (error) {
				console.log("getReadRecords", error?.message);
			}
		},

		// 作业 - 提交已阅读进度
		async submitReadRecords() {
			let params = {
				videoCollectionId: this.$route.query.videosId, //作业下视频集ID
				videoId: this.currentVideo.id, //作业下视频集ID
				id: this.homeworkId, //作业ID
			};
			try {
				let { success, message } = await this.$http.post(
					`h5/examineWork/finisVideo`,params);
				if (!success) throw new Error(message);
				this.getReadRecords();
				// 若是最后一个则提交作业
				if (this.readRecords.length == this.videosDetails.length-1) this.submitHomework();
			} catch (error) {
				this.$message(error?.message)
				console.log("submitReadRecords", error?.message);
			}
		},

		async record() {
			try {
				let { success, message, result } = await this.$http.get(
					`h5/videos/getVideos?videoCollectionId=${this.$route.query.videosId}`
				);
				if (!success) throw new Error(message);
				this.videosDetails = result;
			} catch (error) {
				console.log("getDetails", error?.message);
			}
		},

		async submitHomework() {
			let params = {
				videoCollectionId: this.$route.query.videosId,
				id: this.$route.query.homeworkid || "",
				type: 0, //0-普通视频 1-AI训练
			};
			try {
				let { success, message, result } = await this.$http.post(
					`h5/examineWork/finishWorkInfo`,
					params
				);
				if (!success) throw new Error(message);
				this.$message(message);
				this.getReadRecords();
				this.$router.push;
			} catch (error) {
				// this.$message(error?.message);
				console.log("submitHomework", error);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.details {
	video {
		min-height: 220 / @rem;
		max-height: 220 / @rem;
		object-fit: contain;
		object-position: center;
	}
	.box {
		padding: 11 / @rem 19 / @rem;
		p {
			&.title {
				padding-bottom: 5 / @rem;
				font-size: 19 / @rem;
				font-family: Source Han Sans CN-Medium;
				font-weight: bold;
			}
			&.desc {
				word-break: break-all;
				color: rgba(49, 49, 49, 0.5);
			}
			&.title-sort {
				padding-bottom: 5 / @rem;
				span:first-child {
					// btn_arrow_org
					font-size: 16 / @rem;
					font-family: Source Han Sans CN-Bold;
					font-weight: bold;
				}
				span:last-child {
					font-size: 10 / @rem;
					font-family: Source Han Sans CN-Regular;
					color: rgba(255, 162, 22, 1);
					// &::after {
					// 	content: "";
					// 	display: inline-block;
					// 	width: 10 / @rem;
					// 	height: 10 / @rem;
					// 	background-image: url(~@img/icon/btn_arrow_org.png);
					// 	background-repeat: no-repeat;
					// 	background-size: contain;
					// }
				}
			}
		}
	}

	.exercise-list {
		padding: 0 17 / @rem;
		p.title {
			padding: 10 / @rem 0;
			font-size: 16 / @rem;
			font-weight: bold;
		}
	}

	.tabs {
		flex-wrap: wrap;
		.tab {
			width: 108 / @rem;
			height: 49 / @rem;
			padding: 0 7 / @rem;
			font-size: 11 / @rem;
			font-family: SourceHanSansCN-Regular;
			border-radius: 7 / @rem;
			background-color: white;
			border: 1 / @rem solid rgba(31, 30, 29, 0.2);
			margin-right: 6 / @rem;
			margin-bottom: 6 / @rem;

			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 3;
			overflow: hidden;
			
			&.active {
				color: rgba(255, 162, 22, 1);
				background-color: rgba(254, 198, 51, 0.1);
				border: 1 / @rem solid rgba(255, 162, 22, 1);
			}
			&:nth-child(3n) {
				margin-right: 0;
			}
		}
	}

	.popup-contain {
		padding: 17 / @rem;
		height: 350 / @rem;
		overflow-y: auto;
		p {
			padding-bottom: 13 / @rem;
			font-size: 15 / @rem;
			font-weight: bold;
			color: rgba(47, 47, 47, 1);
			span {
				color: rgba(47, 47, 47, 0.3);
			}
		}
	}
}
</style>
